import { createBrowserRouter } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/auth/Login';
import Dashboard from './pages/Dashboard';
import AuthGuard from './guards/AuthGuard';
import GuestGuard from './guards/GuestGuard';
import Logout from "./pages/auth/Logout";
import Biznisi from "./pages/Biznisi";
import Kategorije from "./pages/Kategorije";
import SignedAgreements from "./pages/SignedAgreements";

const router = createBrowserRouter([
    {
        path: '/',
        element: <Home />,
    },
    {
        element: <GuestGuard />,
        children: [
            {
                path: '/login',
                element: <Login />,
            },
        ],
    },
    {
        element: <AuthGuard />,
        children: [
            {
                path: '/dashboard',
                element: <Dashboard />,
            },
            {
                path: '/biznisi',
                element: <Biznisi />,
            },
            {
                path: '/potpisani-ugovori',
                element: <SignedAgreements />,
            },
            {
                path: '/kategorije',
                element: <Kategorije />,
            },
            {
                path: '/logout',
                element: <Logout />,
            },
        ],
    },
]);

export default router;
